import Popup from './popup.element.js';

export default Popup;

Popup.define('wje-popup', Popup);
